import { render, staticRenderFns } from "./SafetyConfirmRegisterConfirm.vue?vue&type=template&id=32fc23ea&lang=pug"
import script from "./SafetyConfirmRegisterConfirm.vue?vue&type=script&lang=ts"
export * from "./SafetyConfirmRegisterConfirm.vue?vue&type=script&lang=ts"
import style0 from "./SafetyConfirmRegisterConfirm.vue?vue&type=style&index=0&id=32fc23ea&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports